<script lang="ts">
  import data from "../../../../Data/Ecommerce/Ecommerce.json"
  import NewProducts from "./NewProducts.svelte";
  import { CardBody, Label } from "sveltestrap";
  import FilterColor from "./FilterColor.svelte";

</script>
<div class="left-filter">
    <CardBody class="filter-cards-view animate-chk">
      {#each data.leftfilterdata as selectItem}
        <div class="product-filter">
          <h6 class="f-w-600">{selectItem.maintitle}</h6>
          {#each selectItem.select as item}
            <div class="checkbox-animated mt-0">
              <Label class="d-block" for={item.id}>
                <input class="{item.type}_animated" id={item.id} type={item.type} name={item?.name} value={item.title}/>{item.title}
              </Label>
            </div>
          {/each}
        </div>
      {/each}
      <FilterColor />
      <NewProducts />
    </CardBody>
</div>